import React from 'react';
import { ButtonDropdown, Button, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Link } from 'react-router-dom';

const ActionsDropdown = ({ row, toggleDropdown, handleAction, isActive, showEdit, showCheckedIn, isScanned, viewAttentessButton, status, allmenu }) => {
  return (
    <ButtonDropdown direction="up" isOpen={row.dropdownOpen} toggle={() => toggleDropdown(row)}>
      <Button id="caret" color="primary" size="sm" className="custom-button">
        Actions
      </Button>
      <DropdownToggle caret color="primary" size="sm" className="custom-caret">
        <i className="mdi mdi-chevron-up"></i>
      </DropdownToggle>
      <DropdownMenu className="custom-dropdown-menu">
        {!allmenu && (
          <>
            {showCheckedIn ? (
              isScanned ? (<DropdownItem onClick={() => handleAction('checkedout', row)}>Checked-Out</DropdownItem>) : (
                <DropdownItem onClick={() => handleAction('checkedin', row)}>Checked-In</DropdownItem>
              )
            ) : null}
            {isActive ? (
              <DropdownItem onClick={() => handleAction('deactive', row)}>Deactivate</DropdownItem>
            ) : (
              <DropdownItem onClick={() => handleAction('active', row)}>Activate</DropdownItem>
            )}
            {showEdit ? (
              <DropdownItem onClick={() => handleAction('edit', row)}>Edit</DropdownItem>
            ) : null}

            {viewAttentessButton ? (
              <DropdownItem onClick={() => handleAction('attendee', row)}>
                <Link to={`/join-waillist/${row?._id}`}>Join Wailtlist</Link></DropdownItem>
            ) : null}

            <DropdownItem onClick={() => handleAction('delete', row)}>Delete</DropdownItem>
          </>
        )}

        {allmenu && (
          <>
            {status ? (
              <DropdownItem onClick={() => handleAction('status', row)}>
                Change Status</DropdownItem>
            ) : null}

            {viewAttentessButton ? (
              <DropdownItem onClick={() => handleAction('attendee', row)}>
                View </DropdownItem>
            ) : null}
          </>
        )}

      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default ActionsDropdown;
